import { ReactNode } from 'react'
import { cn } from '@/shared/helpers/styles.helper'
import { h2Text, h4Text } from '@/shared/styles/text-sizes'

interface TitleProps {
  children: ReactNode
  className?: string
  id?: string
}

// Words of a translation shown in blue, for its <highlight> tag
export const highlight = (chunks: ReactNode) => (
  <span className='text-primary'>{chunks}</span>
)

// Title of a step redone on the mockup
export const StepTitle: React.FC<TitleProps> = ({
  children,
  className,
  id
}) => (
  <h1 id={id} className={cn(`font-bold ${h2Text} text-foreground`, className)}>
    {children}
  </h1>
)

// Title of a section of a step redone on the mockup
export const SectionTitle: React.FC<TitleProps> = ({ children, className }) => (
  <h2 className={cn(`font-semibold ${h4Text} text-foreground`, className)}>
    {children}
  </h2>
)
